import React from 'react';
import PropTypes from 'prop-types';
import LinkTag from './LinkTag';
import TextTag from './TextTag';

// Modified by AI on 05/26/2026. Edit #1.
const LinkWithTextTag = ({
    url = '',
    label = '',
    onRemove = () => {},
}) => {
    if (url) {
        return <LinkTag url={url} label={label} />;
    }

    return <TextTag text={label} onRemove={onRemove} />;
};

LinkWithTextTag.propTypes = {
    url: PropTypes.string,
    label: PropTypes.string,
    onRemove: PropTypes.func,
};

export default LinkWithTextTag;
